import React from 'react'
import { CategoryBusinessGroupFormStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  InputTextarea,
} from '../../components'
import { ICONS } from '../../themes'

import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class CategoryBusinessGroupFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditPageState: true,
    }
  }

  render() {
    const { isEditPageState } = this.state

    return (
      <CategoryBusinessGroupFormStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_category_management"
                src={ICONS['icon-supplier-discovery-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section
                id="page_title_category_business_group_form"
                className="title"
              >
                {STRING.CATEGORY_MANAGEMENT}
              </Section>

              <Section
                id="page_breadcrumb_category_business_group_form"
                className="breadcrumbs"
              >
                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    redirect(ROUTE_PATH.CATEGORY_MANAGEMENT.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.CATEGORY_MANAGEMENT}</span>
                </Button>

                <Button className="breadcrumb current">
                  {isEditPageState ? (
                    <span>Edit Business Group</span>
                  ) : (
                    <span>Create Business Group</span>
                  )}
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                {isEditPageState
                  ? 'Edit Business Group'
                  : 'Create Business Group'}
              </Section>

              <Section className="form-group is-error">
                <label>Business Group</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <Input type="text" />
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray">Cancel</Button>

              <Button className="theme-green">Save</Button>
            </Section>
          </Section>
        </Section>
      </CategoryBusinessGroupFormStyle>
    )
  }
}
